import { ITimeline, ITimelineDurations, ITimelineEvent } from '../../modules/timeline/types'
import { IQuestionModel } from '../types'

export default function CompositeTimeline({
  id,
  questionModels,
  currentQuestionIndexRef
}: {
  id: string
  questionModels: IQuestionModel[]
  currentQuestionIndexRef: { current: number }
}): ITimeline {
  const timeline: ITimeline = {
    get id() {
      return id
    },
    start(time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.start(time)
      return timeline
    },
    restart(time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.restart(time)
      return timeline
    },
    get started() {
      return Boolean(questionModels[currentQuestionIndexRef.current]?.timeline.started)
    },
    reset() {
      questionModels[currentQuestionIndexRef.current]?.timeline.reset()
      return timeline
    },
    log(event, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.log(event, time)
      return timeline
    },
    _log(event, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline._log(event, time)
      return timeline
    },
    checkpoint(event, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.checkpoint(event, time)
      return timeline
    },
    _checkpoint(event, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline._checkpoint(event, time)
      return timeline
    },
    frameStart(frame, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.frameStart(frame, time)
      return timeline
    },
    frameStarted(frame) {
      return questionModels[currentQuestionIndexRef.current]?.timeline.frameStarted(frame)
    },
    frameInteractionStart(frame, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.frameInteractionStart(frame, time)
      return timeline
    },
    frameCommit(frame, time = Date.now()) {
      questionModels[currentQuestionIndexRef.current]?.timeline.frameCommit(frame, time)
      return timeline
    },
    frameDiscard(frame) {
      questionModels[currentQuestionIndexRef.current]?.timeline.frameDiscard(frame)
      return timeline
    },
    getLog(filter = 'exclude-optional') {
      const log: ITimelineEvent[] = []
      return questionModels.reduce((log, currentQuestionModel) => {
        const currentQuestionLog = currentQuestionModel.timeline.getLog(filter)
        log.push(...currentQuestionLog)
        return log
      }, log)
    },
    getDurations() {
      const durations: ITimelineDurations = { time: [], full_time: [] }
      return questionModels.reduce((durations, currentQuestionModel) => {
        const currentQuestionDurations = currentQuestionModel.timeline.getDurations()
        durations.time.push(...currentQuestionDurations.time)
        durations.full_time.push(...currentQuestionDurations.full_time)
        return durations
      }, durations)
    }
  }
  return timeline
}
